import { config } from "config";

export const environment = {
  production: false,
  apiURL: config.devApiUrl,
  syncFusionLicense: config.syncFusionLicense,
  appVersion: '1.1.0',
  enableDatabaseCopy: true,
  features: {
    calendar: true,
  },
};
